import setPrototypeOf from "./setPrototypeOf.js";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-router-dom/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 1701
// module chunks = 2 3 9